export default {
  steps: [
    { component: 'Start', active: true },
    { component: 'Upload', active: false },
    { component: 'Confirm', active: false },
    { component: 'End', active: false },
    { component: 'InfoEmp', active: false }
  ],
  formFields: {
    useComercial: false,
    cnpj: null,
    cep: null,
    rua: null,
    rua2: null,
    numero: null,
    cidadeRegiao: null,
    complemento: null,
    modalidadeDeEntrega: null,
    descModalidade: null,
    servico: null,
    bairro: null,
    filesPFJ: { arquivo: [] },
    filesPEM: { arquivo: [] },
    formComer: {
      nome: null,
      email: null,
      tel: null
    },
    unitHabitacional: null,
    prevConclusao: null,
    areaTerreno: null,
    nomeSol: null,
    telSol: null,
    cpfSol: null,
    emailSol: null,
    nomeEmpreendimento: null,
    idEmpreendimento: '',
    rgiPde: null,
    formaPagamento: null
  },
  servicos: [],
  modalidadesDeEntrega: [],
  regions: [],
  protocolo: '',
  labels: {
    isNotSanitarySewageCertificate: true,
    tituloDocCliente: 'Documentos pessoa física/jurídica ',
    tituloDocEmpreend: 'Documentos do empreendimento',
    nomeEmpreendimento: 'Nome empreendimento',
    unidadesHabitacionais: 'Número unidades habitacionais',
    previsaoDeLancamento: 'Início do empreendimento',
    previsaoDeConclusao: 'Previsão da entrega'
  }
}
